import React, { Component } from 'react'
import includes from 'lodash/includes'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import without from 'lodash/without'
import * as currentUserDuck from '../../store/shared/currentUserDuck'
import * as userProfileDuck from '../../routes/authenticated/UserProfile/userProfileDuck'
import selectors from '../../store/shared/selectors'
import Tour from '../renderPropComponents/Tour'

const withTour = (tourName, tourSteps = []) => BaseComponent => {
  class WithTourWrapper extends Component {
    static propTypes = {
      currentUserSuccess: PropTypes.func.isRequired,
      isInterestSelectorOpen: PropTypes.bool.isRequired,
      performUpdateUserProfile: PropTypes.func.isRequired,
      toursAutoStart: PropTypes.array,
    }

    static defaultProps = {
      toursAutoStart: [],
    }

    constructor(props) {
      super(props)

      this.state = {
        ready: false,
        shouldRun: false,
      }

      this.handleFinished = async () => {
        try {
          const toursAutoStart = without(this.props.toursAutoStart, tourName)
          const { user } = await this.props.performUpdateUserProfile({ toursAutoStart })
          this.props.currentUserSuccess(user)
          this.setState({ shouldRun: false })
        } catch (error) {
          console.log("ERROR IN HANDLER")
        }
      }
    }

    componentDidMount() {
      this.mounted = true
      setTimeout(() => {
        if(this.mounted) this.setState({ ready: true })
      }, 2500)
    }

    componentWillReceiveProps(nextProps) {
      const nextToursAutoStart = nextProps.toursAutoStart
      const nextIsInterestSelectorOpen = nextProps.isInterestSelectorOpen

      if (includes(nextToursAutoStart, tourName) && !nextIsInterestSelectorOpen) {
        this.setState({ shouldRun: true })
      }
    }

    componentWillUnmount() {
      this.mounted = false
    }

    render() {
      const { ready, shouldRun } = this.state
      return (
        <div>
          <BaseComponent {...this.props} />
          <Tour
            tourSteps={tourSteps || []}
            runTour={ready && shouldRun}
            onRequestClose={this.handleFinished}
          />

        </div>
      )
    }
  }

  const mapStateToProps = state => ({
    toursAutoStart: selectors.getToursAutoStart(state),
    isInterestSelectorOpen: state.interestSelector.isShowingModal,
  })

  const mapDispatchToProps = dispatch => bindActionCreators({
    currentUserSuccess: currentUserDuck.currentUserSuccess,
    performUpdateUserProfile: userProfileDuck.performUpdateUserProfile,
  }, dispatch)

  return connect(mapStateToProps, mapDispatchToProps)(WithTourWrapper)
}

export default withTour



// WEBPACK FOOTER //
// ./src/components/hocs/withTour.js